import type { FC } from "react";
import { ReactComponent as SearchIconNavy } from "./searchIcon-n.svg";
import { ReactComponent as SearchIconWhite } from "./searchIcon-w.svg";

export type SearchFilterButtonProps = {
  isSearchFilterOpen: boolean;
  onClick: () => void;
};

export const SearchFilterButton: FC<SearchFilterButtonProps> = ({
  isSearchFilterOpen,
  onClick,
}: SearchFilterButtonProps) => {
  return (
    <div className="tooltip tooltip-top tooltip-primary " data-tip="絞り込み">
      <button
        className={`border-2 border-[#0F172A] rounded-full p-[6px] mr-4 ${isSearchFilterOpen ? "bg-[#0F172A]" : "bg-white"}`}
        onClick={onClick}
      >
        {isSearchFilterOpen ? (
          <SearchIconWhite className="w-6 h-6 " />
        ) : (
          <SearchIconNavy className="w-6 h-6 " />
        )}
      </button>
    </div>
  );
};
